import { DefaultComposedMenu } from "./default";

export const MenuCompositions = {
    Default: DefaultComposedMenu,
} as const;
